import { useMutation } from "react-query";
import resendOtp from "../services/resendOtp";

function useResendOtp() {
  return useMutation(["resend-otp"], resendOtp);
}

export default useResendOtp;
